<template>
<div class="institutionMContainer">
  <div class="mainContent" :style="styleObject">
    <div class="treeBox fl">
      <tree :data="treeData" @treeData="getTreeData" @currentTreeIdChange="currentTreeIdChangeClick"></tree>
    </div>
    <div class="contentBox fr">
      <div class="title">人员列表</div>
      <div class="handlers">
         <span class="com">用户名：</span>
         <el-input v-model="queryDTO.username" autocomplete="off" placeholder="请输入用户名"></el-input>
          <span class="com">姓名：</span>
         <el-input v-model="queryDTO.name" autocomplete="off" placeholder="请输入姓名"></el-input>
          <span class="com">微信昵称：</span>
         <el-input v-model="queryDTO.nickname" autocomplete="off" placeholder="请输入微信昵称"></el-input>
         <button class="primaryBtn" @click="serachData">搜索</button>
        <button class="primaryBtn" @click="showAddForm" v-if="isPermit('user:add')">新增</button>
      </div>
      <div class="tableWrap">
        <border-table :loading="institutionsLoading" :tableData="users" :tableMaxHeight="tableHeight" :pageSizes="[10, 20, 50]" :pages="pagination" @currentChange="handleCurrentChange" @sizeChange="handleSizeChange">
          <el-table-column prop="id" label="ID" width="80" sortable></el-table-column>
          <el-table-column prop="username" label="用户名"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="tel" label="电话"></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <span style="color:#DD3071">
                <span v-if="scope.row.status === 0" style="color:#DD3071">禁用</span>
                <span v-else-if="scope.row.status === 1" style="color:#28C6A2">正常</span>
                <span v-else-if="scope.row.status === 2" style="color:#E6A23C">锁定</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="orgName" label="所属单位"></el-table-column>
          <el-table-column prop="roleName" label="所属角色"></el-table-column>
          <el-table-column prop="nicknames" label="微信昵称"></el-table-column>
          <el-table-column prop="img" label="微信头像">
            <template slot-scope="scope" v-if="scope.row.headimgurl">
              <img :src="scope.row.headimgurl" style="cursor:pointer" width="30" height="30" @click="imgMask(scope.row.headimgurl)" />
            </template>
          </el-table-column>
          <el-table-column prop="img" label="从业资格证">
            <template slot-scope="scope" v-if="scope.row.img">
              <img :src="scope.row.img" style="cursor:pointer" width="30" height="30" @click="imgMask(scope.row.img)" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" v-if="isPermit('user:edit')||isPermit('user:del')">
            <template slot-scope="scope">
              <el-button v-if="isPermit('user:edit')&&scope.row.level==1" @click="showEditForm(scope.row.id)" size="small" class="edit">编辑</el-button>
              <el-button v-if="isPermit('user:del')&&scope.row.level==1" @click="delUser(scope.row.id)" size="small" class="del">删除</el-button>
              <!-- <el-button v-if="isPermit('user:del')&&scope.row.level==0"  size="small" class="del">查看</el-button> -->
              <el-button v-if="scope.row.status === 2" @click="unlockUser(scope.row.id)" size="small" class="del">解锁</el-button>
              <el-button v-if="scope.row.level==0" @click="seeUser(scope.row.id)" size="small" class="see">查看</el-button>
            </template>
          </el-table-column>
        </border-table>
      </div>
    </div>
  </div>
  <div class="imgMasking" v-if="showImg">
    <div class="closeBtn" @click="showImg = false"><i class="el-icon-circle-close" /></div>
    <div class="imgMask">
      <img :src="imgUrl" alt="">
    </div>
  </div>
  <el-drawer :title="titleShow" size="900px" :modal="false" :visible.sync="dialogShowStatus" @close="closeAddForm" :wrapperClosable="false" direction="rtl" ref="drawer">
    <div class="drawerWrap">
      <div class="drawerBody">
        <el-form ref="adduserForm" :model="userForm" :rules="rules" label-position="right" label-width="120px">
          <el-form-item label="所属单位" prop="orgId" v-if="!userForm.adminFlag">
            <treeselect v-model="userForm.orgId" :disabled="isShow" :multiple=false :defaultExpandLevel="Infinity" :options="orgOptions" placeholder="所属单位" :normalizer="normalizer"  />
          </el-form-item>
          <div>
            <el-form-item label="用户名" prop="username">
              <el-input v-model="userForm.username" :disabled="isShow" minlength="1" maxlength="10" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
              <el-input v-model="userForm.name" :disabled="isShow" minlength="1" maxlength="10" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="tel">
              <el-input v-model="userForm.tel" :disabled="isShow"  maxlength="11" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="是否重置密码" v-if="userForm.id !=0">
              <el-switch v-model="resetPwd" :disabled="isShow" active-text="重置" inactive-text="不重置"></el-switch>
            </el-form-item>
            <el-form-item label="密码" prop="pwd" v-if="userForm.id == 0 || resetPwd ">
              <el-input v-model="userForm.pwd" :disabled="isShow" maxlength="10" placeholder="请输入密码" show-password autocomplete="new-password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPwd" v-if="userForm.id == 0 || resetPwd ">
              <el-input v-model="userForm.confirmPwd" :disabled="isShow" maxlength="10" placeholder="请输入确认密码" show-password  autocomplete="new-password"></el-input>
            </el-form-item>
            <el-form-item label="分配角色" prop="roleIdList" v-if="!userForm.adminFlag"><br />
              <el-transfer :titles="['未选', '已选']" :disabled="isShow" :button-texts="['', '']" v-model="userForm.roleIdList" :props="{key: 'id',label: 'name'}" :data="roleOptions">
              </el-transfer>
            </el-form-item>
            <el-form-item label="从业资格证" prop="img">
              <el-upload :class="{'demo-httpRequestImg':httpRequestImg}" :disabled="isShow" action :limit="1" list-type="picture-card" :http-request="selectPicUpload" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :file-list="fileList" :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </div>

        </el-form>
      </div>
      <div class="drawerFoot">
        <el-button v-if="seeMess" type="primary" @click="addSumit" :loading="addLoading">{{ addLoading ? '提交中' : '提交' }}</el-button>
        <el-button v-if="seeMess" @click="dialogShowStatus = false">取 消</el-button>
        <el-button v-if="!seeMess" type="primary" @click="dialogShowStatus = false">关闭</el-button>
      </div>
    </div>
  </el-drawer>

</div>
</template>

<script>
var qs = require("qs");
var md5 = require("js-md5");
import Tree from "@/components/common/Tree.vue";
import BorderTable from "@/components/common/BorderTable";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: {
    BorderTable,
    Tree,
    Treeselect
  },
  data() {
    return {
      httpRequestImg:false,//展示单个图片
      styleObject: {
        height: ""
      },
      imgFile: null,
      resetPwd: false,
      dialogShowStatus: false,
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      treeData: [],
      tableMaxHeight: 0,
      tableHeight: null,
      institutionsLoading: false,
      rules: {
        orgId: [{
          required: true,
          message: "所属单位不能为空",
          trigger: "change"
        }],
        username: [{
          required: true,
          validator: this.validateUsername,
          trigger: "blur"
        }],
        name: [{
            required: true,
            validator: this.validateName,
            trigger: "blur"
          }
        ],
        tel: [{
          required: true,
          validator: this.validateTel,
          trigger: "blur"
        }],
        pwd: [{
            required: true,
            message: "密码不能为空",
            trigger: "blur"
          },{
            min:1,
            max:10,
            message: "密码长度需要在1-10位之间",
            trigger: "blur"
          }
        ],
        confirmPwd: [{
            required: true,
            validator: this.validateConfirmPwd,
            trigger: "blur"
          },{
              min:1,
              max:10,
              message: "确认密码长度需要在1-10位之间",
              trigger: "blur"
        }],
      },
      orgOptions: [],
      roleOptions: [],
      fileList: [],
      queryFormRoles: [],
      roles: [],
      queryDTO: {
        show: true,
      //   username: "",
        orgId:null,
        roleIds: "",
        page: 1,
        pageSize: 10,
        sort: "id",
        order: "desc",
        total: 0,
        nickname:"",//微信昵称
        username:"",//用户登录名
        name:""//用户名
      },
      addLoading: false,
      userForm: {
        id: 0,
        username: "",
        pwd: "",
        orgId: null,
        roleIdList: [],
        img: "",
        tel:"",
        adminFlag: false
      },
      userOldImg: "", //编辑是记录用户原始头像
      isReuploadImg: false,
      noData: false,
      total: 0,
      dialogTableVisible: false,
      previewImageUrl: "",
      users: [],
      currentTreeId: 0,
      showImg: false,
      imgUrl: '',
      dialogVisible:false,
      dialogImageUrl:'',
      searchText:'',
      seeMess:true,
      isShow:false,
      titleShow:''
    };
  },
  watch: {
    currentTreeId(nVal, oldVal) {
      // handler: (val, olVal) => {//用handler方法，导致this指向改变
      // this.pagination.currentPage=1
      // this.loadUsers();
    },
    screenData() {
      // this.tableHeight = document.body.clientHeight - 300 + "px";
    }
  },

  computed: {
    // screenData() {
    //   return this.$store.state.screen;
    // }
  },
  created() {
     console.log(this.userForm);
     
    this.makeheight();
    this.loadUsers();
    this.showOrgOptions();
    this.showRoleOptions();
  },
  mounted() {},
  methods: {
     serachData() {
      //查询//搜索
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "");
      this.pagination.currentPage = 1;
      
      this.loadUsers();
    },
    getTreeData(data) {
      this.treeData = data;
    },
    currentTreeIdChangeClick(val) {
       console.log(val);
       
      console.log(this.queryDTO.page);
      this.pagination.currentPage = 1;
      this.currentTreeId = val;
      this.loadUsers();
    },
    queryAllRoles(visible) {
      if (!visible) return;
      this.request
        .get(`/role/query/all`)
        .then(data => {
          if (data.code == 200) {
            this.roles = data.data;
          }
        })
        .catch(error => (this.roles = []));
    },
    toggleStatus(row, status) {
      var tip = "";
      if (status == 1) {
        tip = "启用账户";
        if (row.status == 2) {
          tip = "解锁账户"
        }
      } else if (status == 0) {
        tip = "禁用账户";
      } else if (status = 2) {
        tip = "锁定账户24小时"
      }

      this.$confirm("此操作将" + tip + ", 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          let params = {
            userId: row.id,
            status: status
          };
          this.request.post("/user/status", qs.stringify(params)).then(data => {
            if (data.code == 200) {
              this.loadUsers();
              this.msg.success(tip + "成功");
            } else {
              this.msg.error(data.msg);
            }
          });
        })
        .catch(e => {
          this.msg.error(tip + "失败");
        });
    },
    loadUsers() {
      // console.log(this.queryDTO.currentPage);
      // console.log(this.currentTreeId);
      this.queryDTO.orgId = this.currentTreeId;
      this.queryDTO.roleIds =this.queryFormRoles.length == 0 ? "" : this.queryFormRoles.join(",");
      this.institutionsLoading = true;
      this.queryDTO.page=this.pagination.currentPage
      this.queryDTO.pageSize=this.pagination.pageSize
      // console.log(this.queryDTO);
      
      this.request.get("/user/query", this.queryDTO).then(data => {
        if (data.code === 200 && data.data != null) {
          this.users = data.data;
          console.log(this.users);
         //  this.queryDTO.total = data.total;
          this.pagination.total = data.total;
          if (!data.total) {
            this.queryDTO.show = true;
          }
        } else {
          this.users = [];
          this.noData = true;
          this.queryDTO.show = false;
        }
        this.institutionsLoading = false;
      }).catch(e => {
        this.institutionsLoading = false;
      });
    },
    showAddForm() {
       console.log(this.currentTreeId);
       
      this.titleShow="添加用户"
      console.log(this.userForm);
      this.isShow=false
      this.seeMess=true
      this.dialogShowStatus = true;
      this.httpRequestImg=false
      this.userForm.orgId = this.currentTreeId;
      this.userForm.roleIdList=[]
      console.log(this.userForm);
    },
    showOrgOptions() {
      this.request
        .get("/organization/findTreeById?id=0")
        .then(data => {
          console.log(data);
          if (200 === data.code) {
            let orgArr = data.data;
            let arry=[]
            let arrys=[]
            console.log(data.data);
            orgArr.forEach(item=>{
               if(item.children){
                  item.children.forEach(items=>{
                     if(items.children){
                        items.children.forEach(list=>{
                           if(list.children){
                              list.children.forEach(lists=>{
                                 arrys.push({
                                    id:lists.id,
                                    label:lists.label
                                 })
                              })
                           }
                           arrys.push({
                              id:list.id,
                              label:list.label
                           })
                        })
                     }
                     arrys.push({
                        id:items.id,
                        label:items.label
                     })
                  })
               }
              arry.push({
                 id:item.id,
                 label:item.label,
                 children:arrys
              })
            })
            console.log(arry);
            console.log(arrys);
            
            this.orgOptions = arry && arry.length ? arry : [];
          } else {
            this.msg.error(data.msg);
          }
        })
        .catch(e => this.msg.error(e));
    },
    showRoleOptions() {
      this.request
        .get("/role/query/all")
        .then(data => {
          // console.log(data);
          if (200 === data.code) {
            let roleIdList = data.data;
            this.roleOptions =
              roleIdList && roleIdList.length ? roleIdList : [];
          } else {
            // this.msg.error(data.msg);
            this.roleOptions = [];
          }
        })
        .catch(e => this.msg.error(e));
    },
    
    closeAddForm() {
      this.fileList = [];
      this.imgFile = null;
      if (this.$refs["addUserImgUp"]) {
        this.$refs["addUserImgUp"].clearFiles();
      }
      this.resetPwd = false;
      this.isReuploadImg = false;
      this.dialogShowStatus = false;
      this.userForm = {
        id: 0,
        username: "",
        pwd: "",
        orgId: null,
        roleIdList: [],
        img: "",
        tel:"",
        adminFlag: false
      }
      if (this.$refs["adduserForm"]) {
        this.$refs["adduserForm"].clearValidate();
      }
    },
    addSumit() {
      this.$refs["adduserForm"].validate(valid => {
        if (valid) {
          if (!this.userForm.orgId) {
            return this.msg.error("请选择组织结构!");
          }
          
           if (this.userForm.roleIdList.length==0) {
            return this.msg.error("请分配角色!");
          }
          if (this.userForm.pwd) {
            this.userForm.pwd = md5(this.userForm.pwd);
          }
          const formData = new FormData();
          let obj = {
            ...this.userForm
          };
          delete obj.confirmPwd
          Object.keys(obj).forEach(key => {
            // console.log(key, obj[key]);
            formData.append(key, obj[key]);
          });
          if(this.imgFile){
            formData.append("file", this.imgFile)
          }
          this.addLoading = true;
         //  console.log(formData);
         //  return
          var url = this.userForm.id == 0 ? "/user/add" : "/user/edit";
          this.request
            .postParamsForm(url, {}, formData)
            .then(data => {
              if (200 === data.code) {
                this.msg.success(this.userForm.id == 0 ? "添加成功!" : "编辑成功!");
                this.loadUsers();
                this.closeAddForm();
              } else {
                 this.userForm.pwd =this.userForm.confirmPwd
                this.msg.error(data.msg);
              }
              this.addLoading = false;
            })
            .catch(e => {
              this.addLoading = false;
            });
        } else {
          this.addLoading = false;
          this.$message.error("请您按照提示正确填写表单");
          return false;
        }
      });
    },
//编辑修改
    showEditForm(id) {
       this.titleShow="编辑用户"
      this.isShow=false
      this.seeMess=true
      this.httpRequestImg=false
      console.log(id);
      this.dialogShowStatus = true;
      this.showOrgOptions();
      this.showRoleOptions();
      this.request
        .get(`/user/query/${id}`)
        .then(data => {
          if (data.code === 200 && data.data != null) {
             console.log(data.data);
            this.userForm = data.data;
            console.log(this.userForm);
            if(this.userForm.img!=null&&this.userForm.img!=''){
               let obj = new Object();
               obj.url = this.userForm.img;
               this.fileList.push(obj);
               this.httpRequestImg=true
            }
          } else {
            this.msg.error(data.msg + "，加载错误");
          }
        })
        .catch(e => this.msg.error(e));
    },
   //  handleSizeChange(val) {
   //    this.queryDTO.pageSize = val;
   //    this.loadUsers();
   //  },
   //  handleCurrentChange(val) {
   //    this.queryDTO.page = val;
   //    this.loadUsers();
   //  },
    //表格当前页变化时
    handleCurrentChange(val) {
       console.log(val);
       
      this.pagination.currentPage = val;
      this.loadUsers();
    },
    //表格展示条数变化时
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.loadUsers();
    },
    delUser(id) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        })
        .then(() => {
          this.request.delete("/user/delete/" + id).then(data => {
            if (data.code == 200) {
              this.$message({
                message: `人员已删除!`,
                type: "success"
              });
            } else {
              this.$message({
                message: data.msg,
                type: "error"
              });
            }
            let num = ''
            if (this.pagination.total > 1) {
               num = (this.pagination.total - 1) % this.pagination.pageSize
               if (num == 0) {
               this.pagination.currentPage = this.pagination.currentPage - 1
               }
            }
            this.loadUsers();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    unlockUser(row){
        //账户解锁authId
      console.log(row)
      let params={
         userId:row.id,
         status:1
      }
      this.request.postParamsForm("/user/status",params).then(data => {
         if (data.code == 200) {
            this.msg.success('解锁成功！')
         } else {
            this.msg.warn('解锁失败，请联系管理员！')
         }
      });
    },
    //查看
    seeUser(id){
      this.titleShow="查看用户"
      this.isShow=true
      this.seeMess=false
      this.httpRequestImg=false
      console.log(id);
      this.dialogShowStatus = true;
      this.showOrgOptions();
      this.showRoleOptions();
      this.request
        .get(`/user/query/${id}`)
        .then(data => {
          if (data.code === 200 && data.data != null) {
             console.log(data.data);
            this.userForm = data.data;
            console.log(this.userForm);
            if(this.userForm.img!=null){
               let obj = new Object();
               obj.url = this.userForm.img;
               this.fileList.push(obj);
               this.httpRequestImg=true
            }
          } else {
            this.msg.error(data.msg + "，加载错误");
          }
        })
        .catch(e => this.msg.error(e));
    },
    //图片放大
    imgMask(data) {
      this.imgUrl = data
      this.showImg = true
    },
    //树形结构
    normalizer(node){
      //去掉children=null的属性
      if(node.children==null||node.children=='null'){
        delete node.children;
      }
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      _this.tableHeight = window.innerHeight - 340;
      console.log(_this.tableHeight);
      window.onresize = () => {
        return (() => {
          _this.tableHeight = window.innerHeight - 340;
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    //上传图标事件
    selectPicUpload(obj) {
      console.log(obj);
      this.imgFile = obj.file;
      this.httpRequestImg = true;
    },
    //对上传图片的大小、格式进行限制
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isJPG2 = file.type === "image/jpg";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 1;
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning("只支持jpeg或jpg或png格式图片");
      }
      if (!isLt5M) {
        this.$message.warning("请上传1MB以内的图片!");
      }
      return (isJPG || isJPG2 || isPNG) && isLt5M;
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.imgFile = null;
      this.httpRequestImg = false;
    },
   //  selectPicUpload(obj) {
   //    this.imgFile = obj.file;
   //  },
    validateUsername(rule, value, callback){
      if (value === "") {
        callback(new Error("用户名不能为空"))
      }else {
        var reg=new RegExp(/^[A-Za-z0-9]+$/)
        if (!reg.test(value)) {
          callback(new Error("请输入正确的1-10位由[a-z]/[A-Z]/数字组成的用户名！"));
        } else {
          callback();
        }
      }
    },
    validateName(rule, value, callback){
      if (value === "") {
        callback(new Error("姓名不能为空"))
      }else {
        var reg=new RegExp(/^[\u4e00-\u9fa5]+$/)
        if (!reg.test(value)) {
          callback(new Error("请输入正确的1-10位由汉字组成的姓名！"));
        } else {
          callback();
        }
      }
    },
    validateConfirmPwd(rule, value, callback) {
      console.log(value);
      if (value === "") {
        callback(new Error("确认密码不能为空"))
      }else{
         if (value === this.userForm.pwd) {
            callback()
         } else {
            callback(new Error("确认密码和密码不一致"))
         }
      }
    },
    validateTel(rule, value, callback){
       console.log(value);
       
      if (value === "") {
        callback(new Error("电话号码不能为空"))
      }else {
      //   var reg=new RegExp(/^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/)
         var reg=new RegExp(/^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/)
        if (!reg.test(value)) {
          callback(new Error("格式不合法,请输入正确的11位数字组成的联系方式！"));
        } else {
          callback();
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep  .el-checkbox {
  display: block;
}

::v-deep  .tableContainer .tableWrap .dataTable .el-table__body-wrapper tbody tr td {
  border: none;
  padding: 29px 0;
}

.institutionMContainer {

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .treeBox {
      height: 100%;
      width: 20%;
      box-sizing: border-box;
      box-shadow: 0 0 8px 1px #aaa;
    }

    .contentBox {
      height: 100%;
      width: 78%;
      box-sizing: border-box;
      box-shadow: 0 0 8px 1px #aaa;

      .handlers {
        margin: 10px 0;
        padding: 0 10px;
         .com{
            font-size: 14px;
            font-weight: 400;
            color: #606266;
         }
        &>div {
          height: 54px;
          background: rgba(255, 255, 255, 1);
          border-radius: 4px;
         //  border: 1px dashed rgba(170, 170, 170, 1);
          box-sizing: border-box;
          text-align: center;
          cursor: pointer;

          i {
            display: inline-block;
            width: 14px;
            height: 12px;
            margin-right: 10px;
            vertical-align: middle;
          }

          span {
            display: inline-block;
            vertical-align: middle;
            font-size: 14px;
            color: rgba(51, 51, 51, 1);
            line-height: 56px;
          }
        }
      }

      .title {
        height: 24px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 24px;
        padding: 10px;
      }

      .tableWrap {
        padding: 0 10px 10px;
      }

      .pageBox {
        position: absolute;
        // position: relative;
        width: 100%;
        bottom: 10px;
        text-align: center;
        height: 32px;
        right: 40px;
      }
    }

    .edit,.see {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }
  }

  .imgMasking {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;

    [class*=" el-icon-"],
    [class^=el-icon-] {
      font-size: 50px;
      cursor: pointer;
    }

    .closeBtn {
      position: absolute;
      top: 50px;
      right: 100px;
      font-size: 50px;
      color: #fff;
    }

    .imgMask {
      // width: 600px;
      height: 600px;
      position: absolute;
      top: 50%;
      left: 50%;
      // margin-top: -300px;
      // margin-left: -300px;
      transform: translate(-50%, -50%);
      background: #fff;

      img {
        // width: 100%;
        height: 100%;
      }
    }
  }

}
</style><style lang="scss">
.institutionMContainer {
  .drawerWrap {
    .vue-treeselect {
      width: 270px;
      margin-top: 4px;

      .vue-treeselect__control {
        .vue-treeselect__value-container {
          line-height: 40px;

          .vue-treeselect__placeholder {
            line-height: 40px;
          }

          .vue-treeselect__single-value {
            line-height: 40px;
          }
        }
      }
    }

    .el-transfer {
      .el-transfer-panel {
        text-align: left;
        width: 250px;
      }

      .el-transfer__buttons {
        width: 65px;
        text-align: center;

        .el-button {
          margin: 5px 0;
          width: 56px;
        }
      }
    }

    .el-switch {
      width: 100%;
    }

    .el-image {
      margin-right: 20px;
    }

    .el-form {
      margin-top: 20px;

      .el-form-item__label {
        line-height: 50px;
      }

      .el-form-item__content {
        line-height: 50px;
      }

      .el-select {
        width: 100%;
      }

      .el-input {
        width: 270px;

        .el-input__inner {
          height: 40px;
          line-height: 40px;
        }
      }
    }

    .drawerBody .el-form-item__label,
    .sp {
      color: #6e6e6e;
    }

    //多选框
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #2074e6;
      border-color: #2074e6;
    }

    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #2074e6;
    }

    .el-button--primary {
      color: #fff;
      background-color: #2074e6;
      border-color: #2074e6;
    }

    .el-button--primary:focus,
    .el-button--primary:hover {
      background: #4074e6;
      border-color: #4074e6;
      color: #fff;
    }

    .el-form-item__content {
      .el-upload-list--picture-card {
        .el-upload-list__item {
          width: 120px;
          height: 120px;
        }
      }

      .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 122px;
      }
    }
   .demo-httpRequestImg{
      //  ::v-deep  
         .el-upload--picture-card{
            display: none;
         }
   } 
  }
  .handlers{
    .el-input {
      width: 170px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }
  }
}
</style>
